exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#edit-sms-page .box[data-v-307cecf7] {\n  padding: 20px;\n}\n", ""]);

// exports
